import { render, staticRenderFns } from "./CustomerContractHistory.vue?vue&type=template&id=4b4bb021"
import script from "./CustomerContractHistory.vue?vue&type=script&lang=js"
export * from "./CustomerContractHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports